"use client"

import { AdminLayout } from "@/components/admin-layout"
import { useCurrentUser } from "@/features/auth/hooks"
import { HomeActionCards } from "@/features/invoices/components/HomeActionCards"
import { InvoiceListSection } from "@/features/invoices/components/InvoiceListSection"
import { useDocumentTitle } from "@/hooks/use-document-title"

export default function HomePage() {
  useDocumentTitle("Home")
  const { data: currentUser } = useCurrentUser()
  const greetingName = currentUser?.first_name || currentUser?.display_name || "there"

  return (
    <AdminLayout>
      <div className="p-6 max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-h1 text-foreground mb-1">
            Hi, {greetingName}. Here&apos;s what needs attention.
          </h1>
        </div>

        <HomeActionCards />

        <InvoiceListSection />
      </div>
    </AdminLayout>
  )
}
